import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import GroupsIcon from '@mui/icons-material/Groups';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import { FEATURES } from '../../../../config/features';

export function SettingInit({
  generateDownloadTemplate,
  generateDownloadMasterlist,
  generateDownloadForBulkUpdateTemplate,
  generateDownloadEmployeeInformation,
  openUploadForBulkUpdateEmployeeInformationFormHandleClick,
  openUploadFormHandleClick,
  openBiometricsListFormHandleClick,
  generateDownloadLeaveTemplate,
  openUploadLeaveFormHandleClick,
  generateDownloadAddressTemplate,
  openUploadAddressFormHandleClick,
}) {
  return (
    <div id='payroll-setting' className="payroll-setting column">
      <div>
        <div className="flex items-center w-full my-4">
          <div className="ml-4 flex-grow border-t border-gray-300" style={{ borderTop: "1px solid #E0E0E0" }}></div>
          <span className="mx-4 text-gray-600 font-medium" style={{ fontWeight: "bold" }}>Download Informations</span>
          <div className="mr-4 flex-grow border-t border-gray-300" style={{ borderTop: "1px solid #E0E0E0" }}></div>
        </div>
        <div className="payroll-setting-item row" onClick={() => generateDownloadEmployeeInformation(false)}>
          <div style={{ margin: "10px 5px 0 5px", color: "#29aec5" }}><FileOpenIcon /></div>
          Download Employee Information
        </div>
        <div className="payroll-setting-item row" onClick={() => generateDownloadMasterlist(false)}>
          <div style={{ margin: "10px 5px 0 5px", color: "#29aec5" }}><FileOpenIcon /></div>
          Download Masterlist
        </div>
      </div>

      <div>
        <div className="flex items-center w-full my-4">
          <div className="ml-4 flex-grow border-t border-gray-300" style={{ borderTop: "1px solid #E0E0E0" }}></div>
          <span className="mx-4 text-gray-600 font-medium" style={{ fontWeight: "bold" }}>Register Employee/s</span>
          <div className="mr-4 flex-grow border-t border-gray-300" style={{ borderTop: "1px solid #E0E0E0" }}></div>
        </div>
        <div className="payroll-setting-item row" onClick={() => generateDownloadTemplate(false)}>
          <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}><DownloadIcon /></div>
          Download Template
        </div>
        <div className="payroll-setting-item row" onClick={() => openUploadFormHandleClick()}>
          <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}><FileUploadIcon /></div>
          Upload Employee/s
        </div>
        <div className="payroll-setting-item row" onClick={() => openBiometricsListFormHandleClick()}>
          <div style={{ margin: "10px 5px 0 5px", color: "#ffaa00" }}><GroupsIcon /></div>
          Create Employee/s From Biometrics
        </div>
      </div>

      <div>
        <div className="flex items-center w-full my-4">
          <div className="ml-4 flex-grow border-t border-gray-300" style={{ borderTop: "1px solid #E0E0E0" }}></div>
          <span className="mx-4 text-gray-600 font-medium" style={{ fontWeight: "bold" }}>Update Employee's Information</span>
          <div className="mr-4 flex-grow border-t border-gray-300" style={{ borderTop: "1px solid #E0E0E0" }}></div>
        </div>
        <div className="payroll-setting-item row" onClick={() => generateDownloadForBulkUpdateTemplate(false)}>
          <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}><DownloadIcon /></div>
          Download Employee Information Template
        </div>
        <div className="payroll-setting-item row" onClick={() => openUploadForBulkUpdateEmployeeInformationFormHandleClick()}>
          <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}><FileUploadIcon /></div>
          Upload For Bulk Update Employee Information
        </div>
      </div>

      <div>
        <div className="flex items-center w-full my-4">
          <div className="ml-4 flex-grow border-t border-gray-300" style={{ borderTop: "1px solid #E0E0E0" }}></div>
          <span className="mx-4 text-gray-600 font-medium" style={{ fontWeight: "bold" }}>Update Employee's Leaves</span>
          <div className="mr-4 flex-grow border-t border-gray-300" style={{ borderTop: "1px solid #E0E0E0" }}></div>
        </div>
        <div className="payroll-setting-item row" onClick={() => generateDownloadLeaveTemplate(false)}>
          <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}><DownloadIcon /></div>
          Download Employee Leave Template
        </div>
        <div className="payroll-setting-item row" onClick={() => openUploadLeaveFormHandleClick()}>
          <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}><FileUploadIcon /></div>
          Upload Employee/s Leave
        </div>
      </div>

      {FEATURES.USE_NEW_ADDRESS_API &&
        <div>
          <div className="flex items-center w-full my-4">
            <div className="ml-4 flex-grow border-t border-gray-300" style={{ borderTop: "1px solid #E0E0E0" }}></div>
            <span className="mx-4 text-gray-600 font-medium" style={{ fontWeight: "bold" }}>Update Employee's Address</span>
            <div className="mr-4 flex-grow border-t border-gray-300" style={{ borderTop: "1px solid #E0E0E0" }}></div>
          </div>
          <div className="payroll-setting-item row" onClick={() => generateDownloadAddressTemplate(false)}>
            <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}><DownloadIcon /></div>
            Download Employee Address
          </div>
          <div className="payroll-setting-item row" onClick={() => openUploadAddressFormHandleClick()}>
            <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}><FileUploadIcon /></div>
            Upload Employee/s Address
          </div>
        </div>
      }
    </div>
  )
}